(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6752],{

/***/ 1883:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; }
/* harmony export */ });
/* harmony import */ var components_asset_AssetSlug__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(20057);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



var ProjectSlug = function ProjectSlug(_ref) {
  var data = _ref.data,
      similarAssets = _ref.similarAssets;
  var type = "construction";
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(components_asset_AssetSlug__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z, {
    data: data,
    type: type,
    similarAssets: similarAssets
  });
};

var __N_SSG = true;
/* harmony default export */ __webpack_exports__["default"] = (ProjectSlug);

/***/ }),

/***/ 12725:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/construction/[projectSlug]",
      function () {
        return __webpack_require__(1883);
      }
    ]);
    if(false) {}
  

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7611,719,5847,7879,7506,9441,57,9774,2888,179], function() { return __webpack_exec__(12725); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);